export default __webpack_public_path__ + "fonts/10194357ec5e44ae17772744e97560e7.woff";